import { useCallback } from 'react';

import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import { deactivateBuildCacheTrialPath } from '@/utils/monolithApiRouteService';

const useBuildCacheDeactivateFeedback = (
  workspaceSlug: string,
  reasonCategories: string[],
  otherReason: string,
  onSuccess: () => void,
  onError: (error: Error) => void,
) => {
  const { mutate, isPending } = useMonolithApiMutation(deactivateBuildCacheTrialPath(workspaceSlug), 'DELETE', {
    onSuccess: () => onSuccess(),
    onError: (error) => onError(error),
  });

  const submit = useCallback(() => {
    mutate({ reason_categories: reasonCategories, reason_other: otherReason });
  }, [mutate, otherReason, reasonCategories]);

  return {
    submit,
    isPending,
  };
};

export default useBuildCacheDeactivateFeedback;
